
/* REFERENCE:
   Some of the Code below is taken & adapted from Lab Examples of Week 8 and 9. 
*/

// Importing React classes and functions from node modules
import React from "react";

// Default initial value for message context is null.
const MessageContext = React.createContext(null);

// Export MessageContext Constant
export default MessageContext;
